import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Frequency } from '../../types';
import { DateHelper } from 'src/shared/helpers/date';
import { useGetWeekdayPositionInMonth } from 'src/shared/hooks/useGetWeekdayPositionInMonth';
export const useFrequencyDescription = (date) => {
    const { t } = useTranslation();
    const weekday = DateHelper.formatIsoString(date.toISOString(), { weekday: 'long' });
    const { position } = useGetWeekdayPositionInMonth(date);
    const frequencyText = useMemo(() => ({
        [Frequency.Daily]: t('mentorship.form.recurring_session.frequency.options.daily'),
        [Frequency.Weekday]: t('mentorship.form.recurring_session.frequency.options.every_weekday'),
        [Frequency.WeeklyOnDay]: t('mentorship.form.recurring_session.frequency.options.weekly', {
            weekday
        }),
        [Frequency.MonthlyOnLastWeekday]: t('mentorship.form.recurring_session.frequency.options.monthly', {
            day_position_in_month: t('mentorship.day_position_in_month.last'),
            weekday
        }),
        [position.key]: t('mentorship.form.recurring_session.frequency.options.monthly', {
            day_position_in_month: position.text,
            weekday
        })
    }), [t, weekday, position.key, position.text]);
    const getFrequencyDescription = useCallback((recurrenceDescription) => {
        return frequencyText[recurrenceDescription] || '';
    }, [frequencyText]);
    return { getFrequencyDescription };
};
